// CSV export for the pricing audit log: When · Shopify Product Id · Title ·
// From Price · To Price · By. Pure + testable; the page handles fetch-all +
// download.

import { csvCell, csvTimestamp as formatWhen } from '../../utils/csv.js'

const HEADERS = ['When', 'Shopify Product Id', 'Title', 'From Price', 'To Price', 'By']

// Integer pence -> plain 2dp pounds ("300.00"), blank for null. No symbol so it
// stays numeric in a spreadsheet.
function poundsPlain(cents) {
  return cents == null ? '' : (cents / 100).toFixed(2)
}

export function buildAuditCsv(items) {
  const lines = [HEADERS.join(',')]
  for (const e of items || []) {
    lines.push([
      csvCell(formatWhen(e.created_at)),
      csvCell(e.shopify_product_id),
      csvCell(e.title),
      csvCell(poundsPlain(e.old_price_cents)),
      csvCell(poundsPlain(e.new_price_cents)),
      csvCell(e.actor),
    ].join(','))
  }
  return lines.join('\n')
}
